// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__37vOs","row":"ProcedureTreatmentSummary_row__34qev"};